<section>
    <div class="table-container table-responsive">
        <table class="table">
            <thead>
                <tr>
                    <th></th>
                    <th>Descrição</th>
                    <th>Paciente</th>
                    <th>Profissional da Saúde</th>
                    <th>Convênio</th>
                    <th>Data</th>
                    <th>Status</th>
                    <th>Tipo de Consulta</th>
                    <th>Ações</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="
                let consulta of consultas
                  | paginate
                    : {
                        id: 'serverConsulta',
                        itemsPerPage: pageSize,
                        currentPage: pageNumber,
                        totalItems: totalItems
                      }
                ">
                    <td>
                        <div class="d-flex" *ngIf="tipoUsuario != tipoPaciente && !consulta.paciente.hasCadastroCompleto">
                            <button class="btn icon" title="Finalize o cadastro do paciente"
                                (click)="finalizarCadastro(consulta.paciente)">
                                <i class="hgi hgi-stroke hgi-alert-circle"></i>
                            </button>
                        </div>
                        <div class="d-flex" *ngIf="tipoUsuario == tipoPaciente && consulta.hasPedidosPendentes">
                            <button class="btn icon" title="Existem exames pendentes!"
                                (click)="anexarExame(consulta)">
                                <i class="hgi hgi-stroke hgi-alert-circle"></i>
                            </button>
                        </div>
                    </td>
                    <td>{{ consulta.descricao | showDashIfNull}}</td>
                    <td>{{ consulta.paciente.nome | showDashIfNull }}</td>
                    <td>{{ consulta.profissionalSaude.nome | showDashIfNull }}</td>
                    <td>{{ consulta.convenio?.nomeFantasia | showDashIfNull }}</td>
                    <td>{{ consulta.dataConsulta | date: 'dd/MM/yyyy HH:mm' }}</td>
                    <td>{{ consulta.statusConsultaString | showDashIfNull }}</td>
                    <td>{{ consulta.tipoConsultaString | showDashIfNull }}</td>
                    <td>
                        <div class="d-flex flex-row">
                            <div class="d-flex" *ngIf="tipoUsuario != tipoPaciente; else opcoesPaciente">
                                <div class="d-flex" *ngIf="!consulta.paciente.hasCadastroCompleto">
                                    <button class="btn icon icon-golden mr-2" title="Finalizar cadastro"
                                        (click)="finalizarCadastro(consulta.paciente)">
                                        <i class="hgi hgi-stroke hgi-edit-user-02"></i>
                                    </button>
                                </div>
                                <div class="d-flex" *ngIf="consulta.statusConsulta == statusRealizada">
                                    <button class="btn icon icon-ligth-blue" title="Visualizar anexos"
                                        (click)="visualizarAnexos(consulta)">
                                        <i class="hgi hgi-stroke hgi-attachment-02"></i>
                                    </button>
                                </div>
                                <div class="d-flex" *ngIf="consulta.statusConsulta != statusRealizada">
                                    <button *ngIf="consulta.statusConsulta != statusCancelada"
                                        class="btn icon icon-edit" title="Editar consulta" (click)="edit(consulta)">
                                        <i class="hgi hgi-stroke hgi-pencil-edit-02"></i>
                                    </button>

                                    <button *ngIf="consulta.statusConsulta != statusCancelada"
                                        class="btn icon icon-dark-green ml-2" title="Alterar status"
                                        (click)="editStatus(consulta)">
                                        <i class="hgi hgi-stroke hgi-dashboard-square-edit"></i>
                                    </button>

                                    <button *ngIf="consulta.statusConsulta == statusCancelada"
                                        class="btn icon icon-dark-green ml-2" title="Remarcar consulta"
                                        (click)="remarcarConsulta(consulta)">
                                        <i class="hgi hgi-stroke hgi-dashboard-square-edit"></i>
                                    </button>

                                    <div class="d-flex" *ngIf="showTelecosultaOption(consulta)">
                                        <button class="btn icon icon-ligth-blue ml-2" title="Iniciar Consulta"
                                            (click)="iniciarConsulta(consulta)">
                                            <i class="hgi hgi-stroke hgi-video-02"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <ng-template #opcoesPaciente>
                                <div *ngIf="verificarData(consulta.dataConsulta)" class="d-flex">
                                    <button *ngIf="consulta.statusConsulta != statusConfirmada"
                                        class="btn icon icon-dark-green" title="Confirmar consulta"
                                        (click)="confirmarConsulta(consulta)">
                                        <i class="hgi hgi-stroke hgi-checkmark-circle-02"></i>
                                    </button>

                                    <button *ngIf="consulta.statusConsulta != statusRealizada"
                                        class="btn icon icon-edit ml-2" title="Solicitar cancelamento da consulta"
                                        (click)="solicitarCancelamento(consulta)">
                                        <i class="hgi hgi-stroke hgi-cancel-circle"></i>
                                    </button>
                                </div>
                                <button class="btn icon icon-ligth-blue ml-2" title="Visualizar anexos"
                                    (click)="visualizarAnexos(consulta)">
                                    <i class="hgi hgi-stroke hgi-attachment-02"></i>
                                </button>

                                 <button *ngIf="consulta.hasPedidosPendentes" class="btn icon icon-red ml-2" title="Enviar exame"
                                    (click)="anexarExame(consulta)">
                                    <i class="hgi hgi-stroke hgi-medical-file"></i>
                                </button>

                                <button *ngIf="showTelecosultaOption(consulta)" class="btn icon icon-ligth-blue ml-2" title="Iniciar Consulta"
                                    (click)="iniciarConsulta(consulta)">
                                    <i class="hgi hgi-stroke hgi-video-02"></i>
                                </button>
                            </ng-template>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="float-sm-right m-auto">
                <abp-pagination-controls id="serverConsulta" (pageChange)="getDataPage($event)">
                </abp-pagination-controls>
            </div>
        </div>
    </div>
</section>